import React from 'react';
import { faTire } from '@fortawesome/pro-solid-svg-icons/faTire';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function TireSolidIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faTire} {...props} />;
}
